import type { UserResponse } from '~/api-spec/__generated__/main'
import { parseApiResponse } from '~/schema/apiBoundary'

import { type Me, MeSchema } from './schemas'

export const adaptMe = (raw: UserResponse): Me => parseApiResponse(MeSchema, raw, 'Me')
